<template>
	<div
		class="account__block insicht insicht--fade-up"
		v-if="hasFeature('FEATURE_REFERRAL') && !!isLoggedIn && accountReferralUrl"
	>
		<h2 class="account__block-title" v-html="$t('account.referral.title')"/>
		<div class="account__block-text" v-html="$t('account.referral.text')"/>
		<Button
			v-if="$te('account.referral.infoLinkText') && $te('account.referral.infoLinkUrl')"
			type="button"
			:href="$t('account.referral.infoLinkUrl')"
			:text="$t('account.referral.infoLinkText')"
			level="tertiary"
			arrow
		/>
		<input
			class="account__referral-token"
			readonly
			:value="accountReferralUrl"
			@click.prevent="onReferralTokenClick"
		/>

		<ShareButtons
			class="account__referral-buttons"
			:url="accountReferralUrl"
			:email-subject="emailSubject"
			:email-text="emailText"
			:whatsapp-text="whatsappText"
			:facebook-text="facebookText"
			:twitter-text="twitterText"
		/>
	</div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import Button from '@/components/Button'
import ShareButtons from '@/components/ShareButtons'
export default {
	components: {
		Button,
		ShareButtons
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
			"lastOrders",
			"accountLastAddress",
			"accountUserDetail",
			"accountPoinzDetail",
			"accountCoupons",
			"accountReferralUrl"
		]),
		facebookText() {
			return this.$t('account.referral.facebookText', { url: this.accountReferralUrl, brand: this.$t(`brands.${this.themeName}`) }).replace(/\\n/ig, '\n');
		},
		twitterText() {
			return this.$t('account.referral.whatsappText', { url: this.accountReferralUrl, brand: this.$t(`brands.${this.themeName}`) }).replace(/\\n/ig, '\n');
		},
		whatsappText() {
			return this.$t('account.referral.whatsappText', { url: this.accountReferralUrl, brand: this.$t(`brands.${this.themeName}`) }).replace(/\\n/ig, '\n');
		},
		emailText() {
			return this.$t('account.referral.emailText', { url: this.accountReferralUrl, brand: this.$t(`brands.${this.themeName}`) }).replace(/\\n/ig, '\n');
		},
		emailSubject() {
			return this.$t('account.referral.emailSubject', { brand: this.$t(`brands.${this.themeName}`) });
		},
	},
	methods: {
		onReferralTokenClick(e) {
			e.target.select();
		},
	},
}
</script>

<style>

</style>